<div class="wrapper">
  <div
    class="dropdown-header"
    [class.collapsed]="!isOpened"
    (click)="changeDropdownStatus()"
    (clickOutside)="closeDropdown()"
    appClickOutside
  >
    <h2 class="header-text">{{ selectedItem }}</h2>
    <em class="icon-down"></em>
  </div>
  <div class="dropdown-list" [class.collapsed]="!isOpened">
    <div *ngFor="let item of categories" class="dropdown-item" [class.selected]= "selectedItem === item.name" (click)="onSelectItem(item)">
      <em class="item-icon {{item.icon}}"></em>
      <h2 class="item-text">{{ item.name }}</h2>
    </div>
  </div>
</div>
